<div class="row cfa-toolbar-height">
  @for (tab of cfaTabs; track tab; let i = $index) {
    <div #tabEl
      class="col-auto clicky cfa-toolbar-height cfa-nav-tab"
      [class.disabled]="tab.disabled"
      (click)="clickTab($event, tab, true)" id="tab{{i}}">
      <div class="row justify-content-center cfa-toolbar-height cfa-toolbar-tab"
        [class.active]="tab.active">
        <div class="col cfa-15 cfa-toolbar-tab-label text-center align-self-center"
          [class.text-center]="!tab.childTabs || tab.childTabs.length === 0">
          @if (getActiveChildTab(tab)) {
            <div class="activeChildParentTabName"
              [@slideUpState]="'active'">
              {{tab.label}}
            </div>
          }
          {{getActiveTabName(tab)}}
        </div>
        @if (tab.childTabs && tab.childTabs.length > 0) {
          <div class="col-auto cfa-15 align-self-center text-center pl-1 pr-0" >
            <svg-icon class="cfa-tab-icon"src="https://d4gii57lvoht3.cloudfront.net/images/Arrow_Down.svg"></svg-icon>
          </div>
        }
      </div>
      @if (tab.childTabs && tab.childTabs.length > 0 && tab.expanded) {
        <div class="child-tab-container"
          [@openOverlayState]="'active'"
          [class.mat-app-background]="useMaterialTheme"
          [class.cfaCustomLightTheme]="!useMaterialTheme">
          @for (cTab of tab.childTabs; track cTab; let j = $index; let last = $last) {
            <div class="row cfa-child-nav-tab cfa-toolbar-height"
              [class.active]="cTab.active"
              [class.disabled]="tab.disabled || cTab.disabled"
              (click)="clickTab($event, cTab)" id="cTab{{j}}">
              <div class="col-12 align-self-center cfa-15 text-center">
                {{cTab.label}}
              </div>
            </div>
            @if (!last) {
              <hr class="child-tab-separator">
            }
          }
        </div>
      }
    </div>
  }
</div>
